module.exports = __webpack_public_path__ + "static/Logo_Ministerstwa_Spraw_Zagranicznych-81c88f3ef07b80aafbe51c2a5c34cd6e.png";